import React from "react";
import { observer, inject } from "mobx-react";
import { Row, Col, Table, Form } from "react-bootstrap";
import { RouteComponentProps, Link } from "react-router-dom";
import { STORE_KASSES, STORE_AUTH } from "../../constants";
import { KassesStore } from "../../stores/KassesStore";
import { TablePageHeader } from "../../components/TablePageHeader";
import { LinkContainer } from "react-router-bootstrap";

interface IProps {
    history: any,
    [STORE_KASSES]: KassesStore
}



type Props = IProps & RouteComponentProps<{}>;

@inject(STORE_KASSES, STORE_AUTH)
@observer
export class KassesPage extends React.Component<Props, {}> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    kassesStore = (this.props as any)[STORE_KASSES] as KassesStore;

    componentDidMount() {
        this.kassesStore.loadKasses();
    }


    render() {
        return [
            <TablePageHeader header="Kaccы" reload={this.kassesStore.loadKasses} key="1">
                <Form inline onSubmit={(e: any) => {
                    e.preventDefault();
                    this.kassesStore.loadKasses();
                }}>
                </Form>

            </TablePageHeader>,
            <Row key="2">
                <Col sm={12}>
                    <Table bordered striped className="table-xxs">
                        <thead>
                            <tr>
                                <th className="text-center">Device ID</th>
                                <th className="text-center">Название</th>
                                <th className="text-center">Активна</th>
                                <th className="text-center">По умолчанию</th>
                                <th className="text-center"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.kassesStore.kasses.map((item, index) => <tr key={index}>
                                <td className="text-center">
                                    <LinkContainer to={`/kassesmanagement/kassa/${item.deviceId}`}>
                                        <Link to={`/kassesmanagement/kassa/${item.deviceId}`}>{item.deviceId}</Link>
                                    </LinkContainer>
                                </td>
                                <td className="text-center">{item.name}</td>
                                <td className="text-center">{item.isActive ? 'Активна' : ''}</td>
                                <td className="text-center">{item.isDefault ? 'По умолчанию' : ''}</td>
                            </tr>)}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        ]
    }
}